import styled, { useTheme } from 'styled-components'

import { Typography } from 'components/Typography/Typography'
import { ConnectWallet } from 'modules/ConnectWallet/ConnectWallet'
import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

const NeedHelp = styled.div<{ $hide: boolean }>`
  margin: 80px 0;
  text-align: center;

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    .menuClass {
      right: -102px;
    }
  }

  ${p => p.$hide && `display: none;`}
`

const NeedHelpTitle = styled(Typography)`
  font-size: ${p => p.theme.typography.size.Title2}px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Subtitle2}px;
  }
`

const NeedHelpDescription = styled(Typography)`
  padding: 24px 0;
  color: ${p => p.theme.colors.text.description};
  font-size: ${p => p.theme.typography.size.Label2}px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 16px 0;
    font-size: ${p => p.theme.typography.size.Caption1}px;
  }
`

const HelpContainer = styled.div`
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    display: flex;
    gap: 32px;
    justify-content: space-between;
    max-width: 1200px;
    margin: auto;
  }
`

const HelpCard = styled.div`
  padding: 32px;
  border-radius: 32px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  &: hover {
    background-color: ${p => p.theme.colors.background.active};
    & > div > div > div {
      background-color: ${p => p.theme.colors.text.active};
      & > div {
        color: ${p => p.theme.colors.text.primaryDarkBackground};
      }
    }
  }
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    width: 33.33%;
  }
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-bottom: 16px;
    padding: 24px;
    margin-left: 24px;
    margin-right: 24px;
  }
`

const HelpCardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-bottom: 8px;
  }
`

const HelpNumberContainer = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  background: ${p => p.theme.colors.background.primary};
  margin-right: 16px;
`

export const NeedHelpSection = ({ ref }: { ref: React.Ref<HTMLDivElement> }) => {
  const theme = useTheme()

  const walletAddress = useCurrentWalletAddress()

  return (
    <NeedHelp ref={ref} $hide={!!walletAddress}>
      <NeedHelpTitle>
        Need <span style={{ fontWeight: 600 }}>help</span> joining us?
      </NeedHelpTitle>
      <NeedHelpDescription fontWeight="light">
        Follow the <span style={{ fontWeight: 600 }}>step-by-step </span>instructions to avoid mistakes!
      </NeedHelpDescription>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
        <ConnectWallet menuClass="menuClass" />
      </div>
      <HelpContainer>
        <HelpCard>
          <HelpCardHeader>
            <div>
              <HelpNumberContainer>
                <Typography variant="label1" fontWeight="semiBold">
                  1
                </Typography>
              </HelpNumberContainer>
            </div>
            <Typography variant="subtitle2" style={{ textAlign: 'left' }}>
              Install Sui Snap on MetaMask
            </Typography>
          </HelpCardHeader>
          <Typography variant="label2" style={{ textAlign: 'left' }} color="secondary">
            Visit{' '}
            <a
              href="https://suisnap.com/"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', fontWeight: 600, color: theme.colors.text.primary }}
            >
              SuiSnap.com
            </a>{' '}
            and follow the instructions to install MetaMask Sui Snap, enabling Sui Network support in your MetaMask
            wallet.
          </Typography>
        </HelpCard>
        <HelpCard>
          <HelpCardHeader>
            <div>
              <HelpNumberContainer>
                <Typography variant="label1" fontWeight="semiBold">
                  2
                </Typography>
              </HelpNumberContainer>
            </div>
            <Typography variant="subtitle2" style={{ textAlign: 'left' }}>
              Fund your Wallet with SUI tokens
            </Typography>
          </HelpCardHeader>
          <Typography variant="label2" style={{ textAlign: 'left' }} color="secondary">
            Once your wallet is set up, acquire SUI tokens to start interacting with the Sui Network. You can buy SUI
            from any exchange or transfer them from another wallet.
          </Typography>
        </HelpCard>
        <HelpCard>
          <HelpCardHeader>
            <div>
              <HelpNumberContainer>
                <Typography variant="label1" fontWeight="semiBold">
                  3
                </Typography>
              </HelpNumberContainer>
            </div>
            <Typography variant="subtitle2" style={{ textAlign: 'left' }}>
              Begin your DeFi journey
            </Typography>
          </HelpCardHeader>
          <Typography variant="label2" style={{ textAlign: 'left' }} color="secondary">
            With your wallet ready and funded, you&apos;re now set to explore the world of DeFi with Kai Finance!
          </Typography>
        </HelpCard>
      </HelpContainer>
    </NeedHelp>
  )
}
